import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API_BASE,
});

// Attach Bearer if present (fallback when cookies blocked in cross-domain previews)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("foodglow_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

// Build authenticated URL for <img src=...>
export function fileUrl(path) {
    const token = localStorage.getItem("foodglow_token");
    return `${API_BASE}/files/${path}${token ? `?auth=${encodeURIComponent(token)}` : ""}`;
}

export default api;
